var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"href":'/messages?event='+_vm.event}},[_vm._v(_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }